import { InitialValues, ValidationErrors } from 'forms/types';
import { composeValidators, isBetween, isPresent } from 'forms/validators';

import { BenefitAmountFormValues } from '../form/types';

export const getValidator =
  ({ min, max }: { min: number; max: number }) =>
  ({
    benefitAmount,
    expectIncomeIncrease,
  }: InitialValues<BenefitAmountFormValues>): ValidationErrors<BenefitAmountFormValues> => {
    const benefitAmountValidators = composeValidators(isPresent, isBetween(min, max));

    return {
      benefitAmount: benefitAmountValidators(benefitAmount),
      expectIncomeIncrease: isPresent(expectIncomeIncrease),
    };
  };
